import React from 'react';
import ProgressIcon from '../icons/progress-icon';
import { Hierarchy, Size } from '../constants/constants';
import '../styles/components/_button.component.scss';

export interface ButtonProps {
    text?: string;
    type?: Hierarchy;
    size?: Size;
    isSaving?: boolean;
    disabled?: boolean;
    isOpen?: boolean;
    icon?: React.ReactNode;
    iconRight?: boolean;
    onClick: (e: any) => void;
    onHover?: (val: boolean) => void;
    onMouseLeave?: () => void;
}

export default function ButtonComponent({
    text,
    type = 'primary',
    size = 'md',
    isSaving = false,
    disabled = false,
    isOpen = false,
    icon,
    iconRight = false,
    onHover,
    onMouseLeave,
    onClick
}: ButtonProps) {
    const onButtonClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClick(e);
    };

    const handleMouseEnter = () => {
        if (onHover) {
            onHover(true);
        }
    };

    const handleMouseLeave = () => {
        if (onHover) {
            onHover(false);
        }

        if (onMouseLeave) {
            onMouseLeave();
        }
    };

    return (
        <button
            type="button"
            className={`isp__button-component ${type} ${size} ${isSaving ? 'saving' : ''} ${isOpen ? 'open' : ''} ${
                icon && text ? (iconRight ? 'icon-right' : 'icon-left') : ''
            }${!text ? 'icon-only' : ''}`}
            disabled={disabled}
            onClick={onButtonClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <div className="inner-content">
                {icon && !iconRight && !isSaving && icon}
                {isSaving && <ProgressIcon />} {text && text}
                {icon && iconRight && icon}
            </div>
        </button>
    );
}
